/**
 * OLTNode - Custom React Flow node for OLT
 */
import React from 'react';
import { Handle, Position, NodeProps } from '@xyflow/react';
import './FiberTopologyNodes.css';

export interface OLTNodeData {
  label: string;
  port: number;
  power: number; // dBm
  poleId: number;
}

export const OLTNode: React.FC<NodeProps> = ({ data: nodeData, selected }) => {
  const data = nodeData as unknown as OLTNodeData;

  return (
    <div className={`fiber-node olt-node ${selected ? 'selected' : ''}`}>
      <div className="node-header">
        <span className="node-icon">🏢</span>
        <span className="node-title">OLT</span>
      </div>
      <div className="node-body">
        <div className="node-field">
          <span className="field-label">Port:</span>
          <span className="field-value">{data.port}</span>
        </div>
        <div className="node-field">
          <span className="field-label">Power:</span>
          <span className="field-value">{data.power} dBm</span>
        </div>
        <div className="node-field">
          <span className="field-label">Stĺpik:</span>
          <span className="field-value">{data.label}</span>
        </div>
      </div>
      <Handle
        type="source"
        position={Position.Right}
        id="output"
        className="fiber-handle source-handle"
      />
    </div>
  );
};

